<template>
    <AppHeaderDropdown>
        <template slot="header">
            <span class="active">{{ $t('values.moduleName') }}</span>
            <span v-if="evaluations" style="background-color: rgb(248, 108, 107)" class="notification-pill" />
        </template>
        <template slot="dropdown">
            <template v-if="hasValues">
                <b-dropdown-item to="/v2/values/networks" v-if="canViewValuesSetup">
                    {{ $t('values.networks') }}
                </b-dropdown-item>
                <b-dropdown-item to="/v2/values/scales" v-if="canViewValuesSetup">
                    {{ $t('values.scales') }}
                </b-dropdown-item>
                <b-dropdown-item to="/v2/values/categories" v-if="canViewValuesSetup">
                    {{ $t('values.categories') }}
                </b-dropdown-item>
                <b-dropdown-item to="/v2/values/subjects" v-if="canViewValuesSetup">
                    {{ $t('values.subjects') }}
                </b-dropdown-item>
                <b-dropdown-item to="/v2/values/questionnaires" v-if="canViewValuesSetup">
                    {{ $t('values.questionnaires') }}
                </b-dropdown-item>
            </template>
            <b-dropdown-item :to="`/v2/values/valuers/${currentUserId}`">
                {{ $t('values.myNetwork') }}
            </b-dropdown-item>
            <b-dropdown-item to="/v2/values/evaluations">
                <span>
                    {{ $t('values.evaluate') }}
                    <b-badge variant="danger" class="position-static my-auto float-right" v-if="evaluations">
                        <span style="color: white">{{ evaluations }}</span>
                    </b-badge>
                </span>
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
    name: 'DefaultTalkDropdown',
    components: {
        AppHeaderDropdown,
    },
    props: ['currentUserId', 'isGod', 'isAdmin', 'hasValues', 'evaluations', 'isValuesMaster', 'isLocalAdministrator'],
    computed: {
        canViewValuesSetup() {
            return this.isGod || this.isAdmin || this.isValuesMaster || this.isLocalAdministrator
        },
    },
}
</script>
